import useTakeOffer from './useTakeOffer' // Update the path as needed
import {
  OfferPricingType,
  PercentageType,
} from 'src/common/apollo/types/swarmx/graphql'
import { ZERO } from 'src/common/utils/big-utils'
import { isBlockOffer } from 'src/common/utils/offers'
import { AssetHelper } from 'src/common/utils/offers/assetHelper'
import { OfferWithTake } from 'src/common/utils/offers/findBestOffers'
import useConfig from 'src/config/hooks/useConfig'
import useApproveToken from '../../token/useApproveToken'

interface TakeSingleOfferParams {
  offer: OfferWithTake | undefined
}

const useTakeSingleOffer = () => {
  const config = useConfig()
  const { takeOfferFixed, takeOfferDynamic } = useTakeOffer()
  const approveToken = useApproveToken()

  const takeSingleOffer = ({ offer }: TakeSingleOfferParams) => {
    if (!offer) return
    if (offer.withdrawalAsset.type !== 'ERC20') return

    const approveTokenTx = approveToken({
      spender: config.contractsAddresses.dotcContractAddress,
      tokenAddress: offer.withdrawalAsset.contractAddress,
      tokenType: offer.withdrawalAsset.type,
      amount: offer.toTake,
    })

    let takeOffexTx: ReturnType<typeof takeOfferFixed>;

    if (offer.offerPrice.pricingType === OfferPricingType.FixedPricing) {
      takeOffexTx = takeOfferFixed({
        offerId: offer.id,
        withdrawalAmountPaid: offer.toTake,
        decimals: offer.withdrawalAsset.decimals,
        affiliate: '',
      })
    } else {
      takeOffexTx = takeOfferDynamic({
        offerId: offer.id,
        withdrawalAmountPaid: isBlockOffer(offer) ? ZERO : offer.toTake,
        maximumDepositToWithdrawalRate: offer.depositToWithdrawalRate
          ? AssetHelper.calcRateWithPercentage(
              offer.depositToWithdrawalRate,
              500n,
              PercentageType.Plus
            )
          : 0n,
        decimals: offer.withdrawalAsset.decimals,
        affiliate: '',
      })
    }

    return [
      approveTokenTx,
      takeOffexTx
    ]
  }

  return takeSingleOffer
}

export default useTakeSingleOffer
